import { Alert, Button, Descriptions, Modal } from 'antd';

import useLocale from '../../../hooks/useLocale';
import type { ClientService } from '../../../shared/api/ClientService';
import { CopyableId, DetailGroup } from './DetailParts';
import EventStatusTag from './EventStatusTag';
import { DETAIL_MODAL_WIDTH, EMPTY_VALUE } from './constants';
import { formatDateTime } from './utils';

interface IProps {
  event?: ClientService.IntegrationEventDto;
  open: boolean;
  onClose: () => void;
}

const EventDetailModal = ({ event, open, onClose }: IProps): JSX.Element => {
  const { t } = useLocale();

  return (
    <Modal
      centered
      destroyOnClose
      open={open}
      title={t.INTEGRATION_EVENT_DETAILS_TITLE}
      width={DETAIL_MODAL_WIDTH}
      className="integration-monitoring__detail-modal"
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          {t.CLOSE}
        </Button>
      }
    >
      {event && (
        <DetailGroup>
          <Descriptions.Item label={t.INTEGRATION_EVENT_ID}>
            <CopyableId value={event.id} />
          </Descriptions.Item>
          <Descriptions.Item label={t.INTEGRATION_EVENT_TYPE}>{event.eventType || EMPTY_VALUE}</Descriptions.Item>
          <Descriptions.Item label={t.STATUS}>
            <EventStatusTag status={event.status} />
          </Descriptions.Item>
          <Descriptions.Item label={t.INTEGRATION_OCCURRED}>{formatDateTime(event.occurredTime)}</Descriptions.Item>
          <Descriptions.Item label={t.INTEGRATION_RECEIVED}>{formatDateTime(event.receivedTime)}</Descriptions.Item>
          <Descriptions.Item label={t.INTEGRATION_FILE_NAME}>{event.fileName || EMPTY_VALUE}</Descriptions.Item>
          <Descriptions.Item label={t.INTEGRATION_FILE_ID}>
            <CopyableId value={event.fileId} />
          </Descriptions.Item>
          <Descriptions.Item label={t.INTEGRATION_CORRELATION_ID}>
            <CopyableId value={event.correlationId} />
          </Descriptions.Item>
          <Descriptions.Item label={t.INTEGRATION_CAN_REAPPLY}>{event.canBeReapplied ? t.YES : t.NO}</Descriptions.Item>
        </DetailGroup>
      )}

      <Alert type="info" showIcon message={t.INTEGRATION_EVENT_NOTICE} />
    </Modal>
  );
};

export default EventDetailModal;
